//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import libUmum from '../library/umum'


export default {
  data() {
    return {
      form: {
        id: "",
        masterjk: "",
        masterpendidikan : '',
        masterpekerjaan : '',
        layanan : '',

        masterpekerjaan_keterangan : '',


      },

      list_data: [],
      checkAnsweLength : false,

      tahun :'',
      semester : '',
    };
  },
  methods: {
    checkAnswer : function(){
      fetch(this.$store.state.url.URL_kuesioner + "checkAnswer", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            tahun : this.tahun, 
            semester : this.semester
          })
      })
          .then(res => res.json())
          .then(res_data => {
            // console.log("Length")
            // console.log(res_data)

              if (res_data.jml <= 0) {
                this.checkAnsweLength = true;
              } else {
                this.checkAnsweLength = false;
              }
              
              this.getView();
      });
    },
    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_masterKuesioner, {
          method: "GET",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.$store.commit("hideLoading");
              // console.log(res_data.data);
      });
    },

    addData : function(){
      // console.log(this.list_data)
      var data = this.list_data;
      var allow = true;

      data.forEach(data1 => {
        if (data1.jawaban == null || data1.jawaban == undefined || data1.jawaban == '' ) {
          allow = false
        }
      });


      // console.log(this.form)


      if (
        this.form.masterjk == '' ||
        this.form.masterpendidikan == '' ||
        this.form.masterpekerjaan == '' ||
        this.form.layanan == '' 
      ) {
        allow = false;
      } 



      if (allow == false) {
        alert('Mohon Lengkapi dulu datanya ... :)')
      } else {
        


        this.$store.commit("shoWLoading");

        fetch(this.$store.state.url.URL_kuesioner + "addData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              profil : this.form,
              kuesioner : this.list_data,
              tahun : this.tahun,
              semester : this.semester
            })
        }).then(res_data => {
          this.$store.commit("hideLoading");
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.checkAnswer();


        });









      }



    },
   
    // ====================================== PAGINATE ====================================
    Notify: function(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500
      });
    },
    btn_prev: function() {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.checkAnswer();
    }

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    
    var date = new Date();
    this.tahun = date.getUTCFullYear();
    var bulan = date.getMonth();
    this.semester = libUmum.semesterNumber(bulan+1)
    this.checkAnswer();
  }
};
